import React from 'react'
import { Section, GuideHeader, P, UI, Steps, Callout } from './GuideParts'

export default function RecycleBinGuide() {
  return (
    <div className="space-y-8">
      <GuideHeader
        title="Recycle Bin"
        intro="A safety net for data removed by retention policies."
      />

      <Section number={1} title="What Lands in the Recycle Bin">
        <P>
          When a data retention policy deletes items, they are not gone straight away. They sit in the <UI>Recycle Bin</UI> for
          <span className="font-semibold"> 30 days</span> and then are permanently deleted. Each item shows how long is left
          (“3 days left”, “Expiring today”). The list is on the Recycle Bin page, and each template’s Retention tab also has a Recycle Bin view.
        </P>
      </Section>

      <Section number={2} title="Restoring an Item">
        <Steps>
          <li>Open the Recycle Bin and find the item. Items running out of time are highlighted.</li>
          <li>Choose <UI>Restore</UI>. The item returns to where it was.</li>
        </Steps>
        <Callout kind="warn">
          After the 30 days an item cannot be recovered. A Reader can look but not restore.
        </Callout>
      </Section>
    </div>
  )
}
